import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';

@Component({
    selector: 'app-attachments-form',
    templateUrl: './attachments-form.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    encapsulation: ViewEncapsulation.None
})
export class AttachmentsFormComponent implements OnInit {
    @Input() accessionNumber!: string;

    formControlName = 'attachments';
    formGroup!: UntypedFormGroup;
    formElementModels = {
        attachments: new FormElementModel({
            id: 'attachments',
            fieldName: 'Attachments',
            label: 'Please add attachments related to feedback here:'
        })
    };

    constructor(public parent: FormGroupDirective, private readonly fb: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.formGroup = this.fb.group({
            attachments: [[]]
        });

        this.parent.form.addControl(this.formControlName, this.formGroup);
    }
}
